export const EXPERIMENT_NO_ADS = "noAds";
export const EXPERIMENT_SFW = "sfw";
export const EXPERIMENT_CFP = "cfp";
export const EXPERIMENT_TRENDING_CURATION = "013-trending-curation-experiment";
export const EXPERIMENT_CONTEXT_BASED_RECOMMENDATIONS = "008-context-based-recommendations-experiment";
export const EXPERIMENT_NICHE_HOT_FEED = "019-niche-hot-feed-experiment";
export const EXPERIMENT_TRENDING_NICHES_POSITION_EXPERIMENT = "020-trending-niches-position-experiment";

export const VARIANT_CONTROL = "control";
export const VARIANT_TREATMENT = "treatment";
export const VARIANT_OFF = "off";

export const VARIANT_ESTABLISHED = "established";

export const EXPERIMENT_COVERAGE_MAP: {[key: string]: number} = {
  [EXPERIMENT_TRENDING_CURATION]: 0.06,
  [EXPERIMENT_CONTEXT_BASED_RECOMMENDATIONS]: 0.06,
  [EXPERIMENT_NICHE_HOT_FEED]: 0.06,
  [EXPERIMENT_TRENDING_NICHES_POSITION_EXPERIMENT]: 0.06,
};

export const TRENDING_CURATION_VARIANT_LIST = [
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_ESTABLISHED,
    value: VARIANT_ESTABLISHED
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];

export const DEFAULT_VARIANT_LIST = [
  {
    label: VARIANT_TREATMENT,
    value: VARIANT_TREATMENT
  },
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];
